export const SET_CLEARNEWSPECSTATE = "SET_CLEARNEWSPECSTATE";
export const SET_UPLOADED_FILE = "SET_UPLOADED_FILE";
export const SET_TABS = "SET_TABS";